import { FC, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { isBrowserOutdated } from '../shared/helpers/browsersSupport/browserSupport.helper';
import { authService } from '../shared/services/auth/auth.service';
import { isModuleAccess } from './helper.accessParams.ts';

// Authentication is gated upstream at the loader level (lazy.util) and reactively
// by the auth library's AuthProvider via the /login route. ProtectedRoute only
// enforces the FAW module-access check for the current location, so it never
// navigates to '/login' itself — that would race with the loader-level redirect
// and (when '/login' is missing from a route table) land users on '/404'.
export const ProtectedRoute: FC<IProtectedRoute> = ({ children }) => {
  const [ready, setReady] = useState<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isBrowserOutdated()) {
      navigate('/outdated-browsers', { replace: true });
      return;
    }
    const unsub = authService.sub.getCachedUserAccessParams().subscribe((userAccessParams) => {
      if (!isModuleAccess(userAccessParams, location)) {
        navigate('/no-access');
      }
      setReady(true);
    });
    return () => {
      unsub.unsubscribe();
    };
  }, []);

  if (ready) {
    return <>{children}</>;
  }
  return null;
};

export interface IProtectedRoute {
  children: React.ReactElement;
}
